webpackJsonp([253011397747672],{

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureGrid = function FeatureGrid(_ref) {
	  var gridItems = _ref.gridItems;
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns is-multiline' },
	    gridItems.map(function (item) {
	      return _react2.default.createElement(
	        'div',
	        { key: item.image, className: 'column is-6' },
	        _react2.default.createElement(
	          'section',
	          { className: 'section' },
	          _react2.default.createElement(
	            'p',
	            { className: 'has-text-centered' },
	            _react2.default.createElement('img', { alt: '', src: item.image })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.text
	          )
	        )
	      );
	    })
	  );
	};
	
	FeatureGrid.propTypes = {
	  gridItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    image: _propTypes2.default.string,
	    text: _propTypes2.default.string
	  }))
	};
	
	exports.default = FeatureGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pricing = function Pricing(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns' },
	    data.map(function (price) {
	      return _react2.default.createElement(
	        'div',
	        { key: price.plan, className: 'column' },
	        _react2.default.createElement(
	          'section',
	          { className: 'section' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'has-text-centered has-text-weight-semibold' },
	            price.plan
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'is-size-1 has-text-weight-bold has-text-primary has-text-centered' },
	            '$',
	            price.price
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'has-text-weight-semibold' },
	            price.description
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            price.items.map(function (item) {
	              return _react2.default.createElement(
	                'li',
	                { key: item, className: 'is-size-5' },
	                item
	              );
	            })
	          )
	        )
	      );
	    })
	  );
	};
	
	Pricing.propTypes = {
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    plan: _propTypes2.default.string,
	    price: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    description: _propTypes2.default.string,
	    items: _propTypes2.default.array
	  }))
	};
	
	exports.default = Pricing;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimonials = function Testimonials(_ref) {
	  var testimonials = _ref.testimonials;
	  return _react2.default.createElement(
	    'div',
	    null,
	    testimonials.map(function (testimonial) {
	      return _react2.default.createElement(
	        'article',
	        { className: 'message' },
	        _react2.default.createElement(
	          'div',
	          { className: 'message-body' },
	          testimonial.quote,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'cite',
	            null,
	            ' \u2013 ',
	            testimonial.author
	          )
	        )
	      );
	    })
	  );
	};
	
	Testimonials.propTypes = {
	  testimonials: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    quote: _propTypes2.default.string,
	    author: _propTypes2.default.string
	  }))
	};
	
	exports.default = Testimonials;
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.productPageQuery = exports.ProductPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Features = __webpack_require__(110);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Testimonials = __webpack_require__(112);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _Pricing = __webpack_require__(111);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPageTemplate = exports.ProductPageTemplate = function ProductPageTemplate(_ref) {
	  var image = _ref.image,
	      title = _ref.title,
	      heading = _ref.heading,
	      description = _ref.description,
	      intro = _ref.intro,
	      main = _ref.main,
	      testimonials = _ref.testimonials,
	      fullImage = _ref.fullImage,
	      pricing = _ref.pricing;
	  return _react2.default.createElement(
	    'section',
	    { className: 'section section--gradient' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'full-width-image-container margin-top-0',
	                  style: { backgroundImage: 'url(' + image + ')' }
	                },
	                _react2.default.createElement(
	                  'h2',
	                  {
	                    className: 'has-text-weight-bold is-size-1',
	                    style: {
	                      boxShadow: '0.5rem 0 0 #f40, -0.5rem 0 0 #f40',
	                      backgroundColor: '#f40',
	                      color: 'white',
	                      padding: '1rem'
	                    }
	                  },
	                  title
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'columns' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'column is-7' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'has-text-weight-semibold is-size-2' },
	                    heading
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    description
	                  )
	                )
	              ),
	              _react2.default.createElement(_Features2.default, { gridItems: intro.blurbs }),
	              _react2.default.createElement(
	                'div',
	                { className: 'columns' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'column is-7' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'has-text-weight-semibold is-size-3' },
	                    main.heading
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    main.description
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tile is-ancestor' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tile is-vertical' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tile' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tile is-parent is-vertical' },
	                      _react2.default.createElement(
	                        'article',
	                        { className: 'tile is-child' },
	                        _react2.default.createElement('img', {
	                          style: { borderRadius: '5px' },
	                          src: main.image1.image,
	                          alt: main.image1.alt
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tile is-parent' },
	                      _react2.default.createElement(
	                        'article',
	                        { className: 'tile is-child' },
	                        _react2.default.createElement('img', {
	                          style: { borderRadius: '5px' },
	                          src: main.image2.image,
	                          alt: main.image2.alt
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tile is-parent' },
	                    _react2.default.createElement(
	                      'article',
	                      { className: 'tile is-child' },
	                      _react2.default.createElement('img', {
	                        style: { borderRadius: '5px' },
	                        src: main.image3.image,
	                        alt: main.image3.alt
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_Testimonials2.default, { testimonials: testimonials }),
	              _react2.default.createElement('div', {
	                className: 'full-width-image-container',
	                style: { backgroundImage: 'url(' + fullImage + ')' }
	              }),
	              _react2.default.createElement(
	                'h2',
	                { className: 'has-text-weight-semibold is-size-2' },
	                pricing.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'is-size-5' },
	                pricing.description
	              ),
	              _react2.default.createElement(_Pricing2.default, { data: pricing.plans })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	ProductPageTemplate.propTypes = {
	  image: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  heading: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  intro: _propTypes2.default.shape({
	    blurbs: _propTypes2.default.array
	  }),
	  main: _propTypes2.default.shape({
	    heading: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    image1: _propTypes2.default.object,
	    image2: _propTypes2.default.object,
	    image3: _propTypes2.default.object
	  }),
	  testimonials: _propTypes2.default.array,
	  fullImage: _propTypes2.default.string,
	  pricing: _propTypes2.default.shape({
	    heading: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    plans: _propTypes2.default.array
	  })
	};
	
	var ProductPage = function ProductPage(_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.markdownRemark.frontmatter;
	
	
	  return _react2.default.createElement(ProductPageTemplate, {
	    image: frontmatter.image,
	    title: frontmatter.title,
	    heading: frontmatter.heading,
	    description: frontmatter.description,
	    intro: frontmatter.intro,
	    main: frontmatter.main,
	    testimonials: frontmatter.testimonials,
	    fullImage: frontmatter.full_image,
	    pricing: frontmatter.pricing
	  });
	};
	
	ProductPage.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = ProductPage;
	var productPageQuery = exports.productPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-page-js-3d8ecb1e2eee476219e9.js